import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal, Popover, message, Input } from "antd";
import { find } from 'lodash';
import dayjs from 'dayjs';

import * as constants from '../constants';
import {
    loadChangelog
} from '../actions';
import ViewChangelogForm from './ViewChangelogForm';

import core from '../../core';
import uistate from '../../uistate';
import common from '../../../common';

const { GenericTable } = core;


class ChangelogGrid extends Component {

    state = {
        editFormVisible: false,
        currentEditEntity: {},
    };

    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'ChangelogGrid', key);
    }

    //#region Grid button handlers
    onRefreshFiles = () => {
        this.props.loadChangelog(this.props.idProcessingActivity);
    }

    onViewClicked = (id) => {
        const editentity = find(this.props.logitems, { 'id': id });
        this.setState({
            currentEditEntity: editentity,
            editFormVisible: true,
        });
    }

    //#endregion    

    //#region Form handlers

    handleCancelForm = (e) => {
        this.setState({
            editFormVisible: false,
            currentEditEntity: {},
        });
    }

    //#endregion

    render() {
        const readOnly = this.props.readOnly ? this.props.readOnly : false;
        const columns = [{
            title: this.label('CreatedBy'),
            width: '300px',
            dataIndex: 'createdBy',
            key: 'createdBy',
            sorter: (a, b) => ('' + a.createdBy).localeCompare(b.createdBy),
        }, {
            title: this.label('CreatedOn'),
            width: '100px',
            dataIndex: 'createdOn',
            key: 'createdOn',
            sorter: (a, b) => {
                if (dayjs(a.createdOn).isBefore(dayjs(b.createdOn))) {
                    return -1;
                }
                return 1;
            },
            render: (text, record) => (
                <span>
                    {dayjs.utc(record.createdOn).format('DD-MM-YYYY')}
                </span>
            )
        }, {
            title: this.label('Changes'),
            dataIndex: 'changes',
            key: 'changes',
            sorter: (a, b) => ('' + a.changes).localeCompare(b.changes),
            render: (text, record) => (
                <div style={{all: 'initial'}}>
                    <div style={{height: '200px', overflowY: 'scroll'}} dangerouslySetInnerHTML={{ __html: record.changes }} />
                </div>
                // <Input.TextArea value={record.changes} onPressEnter={null} readOnly={true} rows={5} />
            )
        }];

        return (
            <div className='changelog'>
                <GenericTable aligntop multiline columns={columns} data={this.props.logitems} keyfield='id' itemName={this.label('LogItem')} pagesize={20}
                    readOnly={readOnly}
                    onView={this.onViewClicked}
                    onRefresh={this.onRefreshFiles}
                    onDoubleClick={this.onViewClicked} />

                <Modal title={this.label("EditModalTitleForm")} width='80%' destroyOnHidden={true}
                    open={this.state.editFormVisible}
                    footer={null}
                    onCancel={this.handleCancelForm}
                >
                    <ViewChangelogForm datacontext={this.state.currentEditEntity} onCancel={this.handleCancelForm} />
                </Modal>

            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        logitems: state[constants.NAME].logitems,
        labels: uistate.selectors.uiLabels(state),
    };
}

export default connect(mapStateToProps,
    {
        loadChangelog
    })(ChangelogGrid);  